"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var react_json_view_1 = __importDefault(require("@microlink/react-json-view"));
var material_1 = require("@mui/material");
var Drawer_1 = __importDefault(require("@mui/material/Drawer"));
var react_1 = __importDefault(require("react"));
var react_base16_styling_1 = require("react-base16-styling");
var TextButton_1 = __importDefault(require("atomicComponents/atoms/Buttons/TextButton"));
// const themes = ['bright', 'google', 'ashes', 'brewer', 'monokai', 'colors', 'threezerotwofour', 'summerfruit', 'codeschool'] as const;
var theme = 'bright';
var COLLAPSED_FIELDS = new Set(['accPlatformHistory', 'accountedPaymentTxns', 'object']);
var ViewDoc = function (_a) {
    var item = _a.item;
    var _b = __read(react_1.default.useState(false), 2), drawerOpen = _b[0], toggleDrawer = _b[1];
    var themeObj = react_base16_styling_1.base16Themes[theme];
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(TextButton_1.default, __assign({ onClick: function () { return toggleDrawer(true); }, size: "small", color: "neutral" }, { children: "View" })), (0, jsx_runtime_1.jsx)(Drawer_1.default, __assign({ anchor: "right", PaperProps: { sx: { backgroundColor: themeObj.base00, padding: [2, 3, 3], color: themeObj.base07 } }, open: drawerOpen, onClose: function () { return toggleDrawer(false); } }, { children: (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ minWidth: "900px" }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ display: "flex", mb: 1 }, { children: [item.companyName, " - ", (0, end2end_1.getISODate)(new Date(item.created * 1000))] })), drawerOpen && ((0, jsx_runtime_1.jsx)(react_json_view_1.default, { displayDataTypes: false, sortKeys: true, name: null, src: item, theme: theme, shouldCollapse: function (field) { return COLLAPSED_FIELDS.has(field.name); } }))] })) }))] }));
};
exports.default = ViewDoc;
